export const LINK_CUSTOMER_GUESTY_ERROR = "LINK_CUSTOMER_GUESTY_ERROR";
export const UNLINK_CUSTOMER_GUESTY_ERROR = "UNLINK_CUSTOMER_GUESTY_ERROR";

export const LINK_CUSTOMER_KROSS_ERROR = "LINK_CUSTOMER_KROSS_ERROR";
export const UNLINK_CUSTOMER_KROSS_ERROR = "UNLINK_CUSTOMER_KROSS_ERROR";
export const LINK_CUSTOMER_KROSS_INVALID_CREDENTIALS_ERROR =
  "LINK_CUSTOMER_KROSS_INVALID_CREDENTIALS_ERROR";
export const LINK_CUSTOMER_KROSS_CONNECTION_ERROR = "LINK_CUSTOMER_KROSS_CONNECTION_ERROR";
export const LINK_CUSTOMER_KROSS_API_ERROR = "LINK_CUSTOMER_KROSS_API_ERROR";

export const LINK_CUSTOMER_ICNEA_INVALID_OWNER_ERROR = "LINK_CUSTOMER_ICNEA_INVALID_OWNER_ERROR";
export const LINK_CUSTOMER_ICNEA_NOT_CONFIGURED_ERROR = "LINK_CUSTOMER_ICNEA_NOT_CONFIGURED_ERROR";
export const LINK_CUSTOMER_ICNEA_ERROR = "LINK_CUSTOMER_ICNEA_ERROR";

export const UPDATE_ICNEA_PASSWORD_ERROR = "UPDATE_ICNEA_PASSWORD_ERROR";
